<template>
    <div class="weather-modal">
        <div @click="closeForm" class="iconButton link">
            <span class="ion-close"></span>
        </div>
        <div class="modal-header drag-handle">
            <h5>Weather Information</h5>
        </div>
          <div class="modal-content padded40">
            <div v-show="loading" class="col m6 s12 centered loader-wrapper">
                  <div class="loading">
                    <pulse-loader :loading="true" color="#C94412" size="25px" :width="100" :height="50"></pulse-loader>
                  </div>
                </div>
              <div v-show="!loading">
              <div class="col m3 s12 weather-col">
                  <h6>Hourly Weather</h6>
                  <h6><template v-if="currentStation && currentStation.hourlyStationName">Station {{currentStation.hourlyStationName}}</template>
                  <template v-else>No hourly weather data found for this station</template></h6>
                  <div class="hourly-condition-wrapper">
                    <template v-if="currentStation && currentStation.hourlyWeather">
                      <div v-for="(condition, index) in currentStation.hourlyWeather" :key="'weather-icon-' + index">
                        <div v-if="condition === 'NA'" >-</div>
                        <img v-else class="weather-icon" :src="iconsSrc[index]"/>
                        <div :key="'condition-' + index">
                          {{condition}}
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div>-</div>
                        <div>
                          NA
                        </div>
                    </template>
                  </div>
                  <div class="row">
                    <div class="weather-item">Distance from Site<span class="data"><template v-if="currentStation && currentStation.hourlyStationDistance">{{currentStation.hourlyStationDistance}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Station Coordinates<span class="data"><template v-if="currentStation && (currentStation.hourlyStationLatitude || currentStation.hourlyStationLongitude)">{{currentStation.hourlyStationLatitude}}, {{currentStation.hourlyStationLongitude}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Station Elevation<span class="data"><template v-if="currentStation && currentStation.hourlyStationElevation">{{currentStation.hourlyStationElevation}}</template><template v-else>--</template></span></div>
                  </div>
                  <div class="row">
                    <div class="weather-item">Temperature <span class="data"><template v-if="currentStation && currentStation.hourlyTemperature">{{currentStation.hourlyTemperature}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Wind Speed <span class="data"><template  v-if="currentStation && currentStation.hourlyWindSpeed">{{currentStation.hourlyWindSpeed}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Dew Point <span class="data"><template v-if="currentStation && currentStation.hourlyDewPoint">{{currentStation.hourlyDewPoint}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Humidex <span class="data"><template v-if="currentStation && currentStation.hourlyHumidex">{{currentStation.hourlyHumidex}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Humidity <span class="data"><template v-if="currentStation && currentStation.hourlyHumidity">{{currentStation.hourlyHumidity}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Precipitation <span class="data"><template v-if="currentStation && currentStation.hourlyPrecipitation">{{currentStation.hourlyPrecipitation}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Pressure <span class="data"><template v-if="currentStation && currentStation.hourlyPressure">{{currentStation.hourlyPressure}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Visibility <span class="data"><template v-if="currentStation && currentStation.hourlyVisibility">{{currentStation.hourlyVisibility}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Windchill <span class="data"><template v-if="currentStation && currentStation.hourlyWindChill">{{currentStation.hourlyWindChill}}</template><template v-else>--</template></span></div>
                    <div class="weather-item">Wind Direction <span class="data"><template v-if="currentStation && currentStation.hourlyWindDirection">{{currentStation.hourlyWindDirection}}</template><template v-else>--</template></span></div>
                  </div>
                </div>
            <div class="col m3 s12 weather-col">
              <h6>Daily Weather</h6>
              <h6><template v-if="currentStation && currentStation.dailyStationName">Station {{currentStation.dailyStationName}}</template>
              <template v-else>No daily weather data found for this station</template></h6>
              <div class="row">
                <div class="weather-item">Distance from Site<span class="data"><template v-if="currentStation && currentStation.dailyStationDistance">{{currentStation.dailyStationDistance}}</template><template v-else>--</template></span></div>
                <div class="weather-item">Station Coordinates<span class="data"><template v-if="currentStation && (currentStation.dailyStationLatitude || currentStation.dailyStationLongitude)">{{currentStation.dailyStationLatitude}}, {{currentStation.dailyStationLongitude}}</template><template v-else>--</template></span></div>
                <div class="weather-item">Station Elevation<span class="data"><template v-if="currentStation && currentStation.dailyStationElevation">{{currentStation.dailyStationElevation}}</template><template v-else>--</template></span></div>
              </div>
              <div class="row">
                <div class="weather-item">Min <span class="data"><template v-if="currentStation && currentStation.dailyMinTemp">{{currentStation.dailyMinTemp}}</template><template v-else>--</template></span></div>
                <div class="weather-item">Max <span class="data"><template v-if="currentStation && currentStation.dailyMaxTemp">{{currentStation.dailyMaxTemp}}</template><template v-else>--</template></span></div>
                <div class="weather-item">Mean <span class="data"><template v-if="currentStation && currentStation.dailyMeanTemp">{{currentStation.dailyMeanTemp}}</template><template v-else>--</template></span></div>
                <div class="weather-item">Precipitation <span class="data"><template v-if="currentStation && currentStation.dailyPrecipitation">{{currentStation.dailyPrecipitation}}</template><template v-else>--</template></span></div>
                <div class="weather-item">Snow on Ground <span class="data"><template v-if="currentStation && currentStation.dailySnowOnGround">{{currentStation.dailySnowOnGround}}</template><template v-else>--</template></span></div>
                <div class="weather-item">Total Rain <span class="data"><template v-if="currentStation && currentStation.dailyTotalRain">{{currentStation.dailyTotalRain}}</template><template v-else>--</template></span></div>
                <div class="weather-item">Total Snow <span class="data"><template v-if="currentStation && currentStation.dailyTotalSnow">{{currentStation.dailyTotalSnow}}</template><template v-else>--</template></span></div>
                </div>
            </div>
          </div>
          <div class="col m6 s12">
            <div class="station-btn-wrapper" v-if="totalStations">
              <button @click="previousStation()" :disabled="currentStationIndex <= 0" class="btn btn-border"><span class="ion-ios-arrow-thin-left"></span> Previous</button>
              {{currentStationIndex + 1}} of {{totalStations}}
              <button @click="nextStation()" :disabled="currentStationIndex + 1 >= totalStations" class="btn btn-border">Next <span class="ion-ios-arrow-thin-right"></span></button>
              </div>
              <location-map ref="map" v-bind:map-type="'weather'" v-bind:category-string="dateString+'&locationId='+locationId" v-bind:site-location="{latitude: siteLatitude, longitude: siteLongitude}"></location-map>
            </div>
          </div>
        </div>
</template>

<script>
import Vue from 'vue'; // required for tooltip
import { VTooltip } from 'v-tooltip';
import { eventBus } from '@/lib/eventbus';
import {API_URL} from '@/lib/common';
import MultiPointMapVue from '../mapGL/MultiPointMap';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'; // spinner for loading
Vue.directive('tooltip', VTooltip);

export default({
  name: 'camera-tagging-form',
  props: ['iconsSrc', 'dateString', 'locationId', 'siteLatitude', 'siteLongitude'],
  components: {'location-map': MultiPointMapVue, 'pulse-loader': PulseLoader},
  created () {
    this.stations = new Map();
    // cache info for closest station
    eventBus.$on('station-update', async (updateObj) => {
      this.currentStationIndex = updateObj.index;
      if (this.stations.has(updateObj.id)) {
        this.currentStation = this.stations.get(updateObj.id);
      } else {
        await this.getMoreStationInfo(updateObj.id);
      }
    });

    eventBus.$on('stations-loaded', (ids) => {
      // get the first station's info
      this.totalStations = ids.length;
      this.getMoreStationInfo(ids[0]);
    });
  },
  methods: {
    closeForm () {
      eventBus.$emit('close-weather-modal');
    },
    async getMoreStationInfo (id) {
      // if we havent cached this station before, call the api
      this.loading = true;
      return this.$http.get(this.getStationDataByClimateIdUrl + this.dateString + '&locationId=' + this.locationId + '&climateId=' + id).then((response) => {
        this.loading = false;
        if (response.body.hasOwnProperty.call('error')) {
          this.currentStation = null;
        } else {
          this.stations.set(id, response.body);
          this.currentStation = response.body;
        }
      }, (err) => {
        // error callback
        this.loading = false;
        console.error(err);
        this.currentStation = null;
      });
    },
    async nextStation () {
      if (this.currentStationIndex + 1 >= this.totalStations) {
        return;
      }
      this.currentStationIndex++;
      let id = this.$refs.map.getNextStation();
      if (this.stations.has(id)) {
        this.currentStation = this.stations.get(id);
      } else {
        await this.getMoreStationInfo(id);
      }
    },
    async previousStation () {
      if (this.currentStationIndex + 1 <= 0) {
        return;
      }
      this.currentStationIndex--;
      let id = this.$refs.map.getPreviousStation();
      if (this.stations.has(id)) {
        this.currentStation = this.stations.get(id);
      } else {
        await this.getMoreStationInfo(id);
      }
    }
  },
  data () {
    return {
      getStationDataByClimateIdUrl: API_URL + 'get-weather-station-data-for-climate?date=',
      stations: null, // (key: climateId, value: weather data)
      currentStation: null,
      totalStations: null,
      currentStationIndex: 0,
      loading: true
    }
  }
})
</script>

<style>
.hourly-condition-wrapper{
  text-align: center;
  color: #C94412;
  height: 75px;
}

.weather-item{
    color: #C94412;
    margin-left: 10px;
}

.weather-item .data{
  color: #1369c5;
  float: right;
  margin-right: 10px;
}

.weather-col h6{
  text-align: center;
}

.station-btn-wrapper{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}

.loader-wrapper{
margin-top: 10px;
}
</style>
